/**
 * Extracts expiry timestamp from WalletConnect URI
 * Example URI: "wc:...@2?...&expiryTimestamp=1758741030&..."
 * Returns null if URI doesn't contain expiry timestamp
 */
export const getWalletConnectExpiryTime = (uri: string): number | null => {
  try {
    const url = new URL(uri);
    const timestamp = url.searchParams.get('expiryTimestamp');

    if (timestamp) {
      const parsed = parseInt(timestamp, 10);
      return !isNaN(parsed) ? parsed : null;
    }

    return null;
  } catch {
    return null;
  }
};
